var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"u-icon material-icons",class:'u-icon-' + _vm.name,style:(_vm.style),attrs:{"size":_vm.size,"href":_vm.href,"disabled":_vm.disabled},on:{"click":_vm.onClick}},_vm.listeners),[_vm._v("\n    "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }